import moment from "moment"

export const DataKey = {
    Count: "count",
}

export const NameKey = {
    Name: "name",
}

export const windowSizeDaysOptions = [
    { label: "5 Days", value: 5 },
    { label: "7 Days", value: 7 },
    { label: "10 Days", value: 10 },
    { label: "15 Days", value: 15 },
    { label: "20 Days", value: 20 },
    { label: "30 Days", value: 30 },
]

export function getTimestamp(start_time, end_time, duration) {
    // const { start_time, end_time, duration } = props
    const formatStyle = "YYYY-MM-DD HH:mm:ss"
    let start_date = start_time
    let end_date = end_time

    if (duration === "custom") {
        start_date = moment(start_time)
        end_date = moment(end_time).add(1439, "minutes").add(59, "seconds")
    } else if (duration === "today") {
        start_date = moment().startOf("day")
        end_date = moment().endOf("day")
    } else if (duration === "this-week") {
        start_date = moment().clone().startOf("isoWeek")
        end_date = moment().clone().endOf("isoWeek")
        if (moment().isBefore(end_date, "day")) {
            end_date = moment().clone()
        }
    } else if (duration == "this-month") {
        start_date = moment().startOf("month")
        end_date = moment().endOf("month")
        if (moment().isBefore(end_date, "day")) {
            end_date = moment().clone()
        }
    } else if (duration == "last-month") {
        start_date = moment().subtract(1, "months").startOf("month")
        end_date = moment().subtract(1, "months").endOf("month")
    } else if (duration == "all") {
        start_date = moment().subtract(2, "year").startOf("year")
        end_date = moment().endOf("year")
        if (moment().isBefore(end_date, "day")) {
            end_date = moment().clone()
        }
    } else {
        start_date = moment().startOf("year")
        end_date = moment().endOf("year")
        if (moment().isBefore(end_date, "day")) {
            end_date = moment().endOf("month")
        }
    }

    const startDate = start_date.format(formatStyle)
    const endDate = end_date.format(formatStyle)

    return { startDate, endDate, duration }
}

export const config = {
    DEFAULT_PAGE: 1,
    DEFAULT_PAGE_SIZE: 10,
    STORAGE_KEY_PREFIX: "app_module_menu",
    EXPANDED_SIDEBAR_APP_KEYS: ["we_home_care", "kaigo_house", "kaigo_demo"],
}

//  Default Messages
export const SNACKBAR_MESSAGES = {
    SUCCESS_DEFAULT: "Request completed successfully.",
    ERROR_DEFAULT: "Something went wrong. Please try again.",
    WARNING_DEFAULT: "Please check the entered details.",
    INFO_DEFAULT: "Here is some important information.",
}

export const LANGUAGE_OPTIONS = {
    en: {
        label: "English",
        shortCode: "EN",
        flag: "🇬🇧",
    },
    fr: {
        label: "French",
        shortCode: "FR",
        flag: "🇫🇷",
    },
    ja: {
        label: "Japanese",
        shortCode: "JA",
        flag: "🇯🇵",
    },
    my: {
        label: "Myanmar",
        shortCode: "MY",
        flag: "🇲🇲",
    },
    th: {
        label: "Thai",
        shortCode: "TH",
        flag: "🇹🇭",
    },
    vi: {
        label: "Vietnamese",
        shortCode: "VI",
        flag: "🇻🇳",
    },
    "zh-CN": {
        label: "Chinese (Simplified)",
        shortCode: "ZH-CN",
        flag: "🇨🇳",
    },
    "zh-TW": {
        label: "Chinese (Traditional)",
        shortCode: "ZH-TW",
        flag: "🇹🇼",
    },
}
